import { NewOrderTypes } from '../../../common/enums/enums';
import {
  clearError,
  clearNewOrder,
  discardOrder,
  saveNewOrder,
  setSelectedVendor,
  getServicesByDepartment,
  addPriceToSelectedPrices,
  removePriceToSelectedPrices,
  alternativeOwner,
  setAlternativeOwner,
  addVehicleDetails,
  closeEditVehicleModal,
  editVehicleDetails,
  getVehicleByVin,
  openEditVehicleModal,
  addSpecialRequest,
  removeSpecialRequest,
  changeCompletionType,
  setPromiseDate,
  updateCreatedDate,
  setAllDealers,
  setStockNumber,
} from '../../../redux/actions/orders/newOrderActions';
import {
  clearServiceOrderError,
  clearServiceOrder,
  discardServiceOrder,
  saveServiceOrder,
  setServiceOrderSelectedVendor,
  getServiceOrderServicesByDepartment,
  addPriceToSelectedServiceOrderPrices,
  removePriceToSelectedServiceOrderPrices,
  serviceOrderAlternativeOwner,
  setServiceOrderAlternativeOwner,
  addServiceOrderVehicleDetails,
  closeServiceOrderEditVehicleModal,
  editServiceOrderVehicleDetails,
  getServiceOrderVehicleByVin,
  openServiceOrderEditVehicleModal,
  addServiceOrderSpecialRequest,
  removeServiceOrderSpecialRequest,
  changeServiceOrderCompletionType,
  setServiceOrderPromiseDate,
  updateServiceOrderCreatedDate,
  setAllServiceOrderDealers,
  setVehicleStockNumber,
} from '../../../redux/actions/orders/newServiceOrderActions';
import {
  selectDataToSave,
  selectDiscarded,
  selectSaveError,
  selectWorkOrderSaved,
  selectIsLoading,
  selectSelectedCategories,
  selectSelectedVendor,
  selectIsLoadingServices,
  selectPricesGrouped,
  selectSelectedDepartment,
  selectSelectedPrices,
  selectSelectedPricesWithDetails,
  selectSelectedVehicle,
  selectSpecialRequests,
  selectedAlternativeOwner,
  selectEditVehicleDataError,
  selectEditVehicleModalOpen,
  selectIsLoadingVehicle,
  selectVehicleNotFound,
  selectAlternativeOwner,
  selectEstimatedCompletion,
  selectCompletionType,
  selectPromiseDate,
  getAllDealers,
  vehicleId,
} from '../../../redux/selectors/orders/newOrderSelectors';
import {
  selectServiceOrderDataToSave,
  selectServiceOrderDiscarded,
  selectServiceOrderSaveError,
  selectServiceOrderWorkOrderSaved,
  selectServiceOrderIsLoading,
  selectServiceOrderSelectedCategories,
  selectServiceOrderSelectedVendor,
  selectServiceOrderIsLoadingServices,
  selectServiceOrderPricesGrouped,
  selectServiceOrderSelectedDepartment,
  getServiceOrderSelectedServicesPrices,
  selectServiceOrderSelectedVehicle,
  selectServiceOrderSpecialRequests,
  selectedServiceOrderAlternativeOwner,
  selectServiceOrderEditVehicleDataError,
  selectServiceOrderEditVehicleModalOpen,
  selectServiceOrderIsLoadingVehicle,
  selectServiceOrderVehicleNotFound,
  selectServiceOrderAlternativeOwner,
  selectServiceOrderEstimatedCompletion,
  selectServiceOrderCompletionType,
  selectServiceOrderPromiseDate,
  getAllServiceOrderDealers,
  serviceOrderVehicleId,
} from '../../../redux/selectors/orders/newServiceOrderSelectors';

export const getSelectorActionsBasedOnType = orderType => {
  let clearErrorAction,
    clearOrderAction,
    discardOrderAction,
    saveOrderAction,
    dataToSaveSelector,
    discardedSelector,
    saveErrorSelector,
    selectWorkOrderSavedSelector,
    isLoadingSelector,
    selectedCategoriesSelector,
    setSelectedVendorAction,
    selectedVendorSelector,
    getServicesByDepartmentAction,
    addPriceToSelectedPricesAction,
    removePriceToSelectedPricesAction,
    alternativeOwnerAction,
    setAlternativeOwnerAction,
    selectIsLoadingServicesSelector,
    selectPricesGroupedSelector,
    selectedDepartmentSelector,
    selectedPricesSelector,
    selectedPricesWithDetailsSelector,
    selectedVehicleSelector,
    specialRequestsSelector,
    choosenAlternativeOwner,
    addVehicleDetailsAction,
    closeEditVehicleModalAction,
    editVehicleDetailsAction,
    getVehicleByVinAction,
    openEditVehicleModalAction,
    eitVehicleDataErrorSelector,
    editVehicleModalOpenSelector,
    isLoadingVehicleSelector,
    vehicleNotFoundSelector,
    addSpecialRequestAction,
    removeSpecialRequestAction,
    alternateOwnerSelector,
    changeCompletionTypeAction,
    setPromiseDateAction,
    updateCreatedDateAction,
    estimatedCompletionSelector,
    completionTypeSelector,
    promiseDateSelector,
    setAllDealersAction,
    getAllDealerSelector,
    setStockNumberForVehicle,
    getVehicleId;
  if (orderType === NewOrderTypes.SERVICE_ORDER) {
    clearErrorAction = clearServiceOrderError;
    clearOrderAction = clearServiceOrder;
    discardOrderAction = discardServiceOrder;
    saveOrderAction = saveServiceOrder;
    dataToSaveSelector = selectServiceOrderDataToSave;
    discardedSelector = selectServiceOrderDiscarded;
    saveErrorSelector = selectServiceOrderSaveError;
    selectWorkOrderSavedSelector = selectServiceOrderWorkOrderSaved;
    isLoadingSelector = selectServiceOrderIsLoading;
    selectedCategoriesSelector = selectServiceOrderSelectedCategories;
    setSelectedVendorAction = setServiceOrderSelectedVendor;
    selectedVendorSelector = selectServiceOrderSelectedVendor;
    getServicesByDepartmentAction = getServiceOrderServicesByDepartment;
    addPriceToSelectedPricesAction = addPriceToSelectedServiceOrderPrices;
    removePriceToSelectedPricesAction = removePriceToSelectedServiceOrderPrices;
    alternativeOwnerAction = serviceOrderAlternativeOwner;
    setAlternativeOwnerAction = setServiceOrderAlternativeOwner;
    selectIsLoadingServicesSelector = selectServiceOrderIsLoadingServices;
    selectPricesGroupedSelector = selectServiceOrderPricesGrouped;
    selectedDepartmentSelector = selectServiceOrderSelectedDepartment;
    selectedPricesSelector = getServiceOrderSelectedServicesPrices;
    selectedPricesWithDetailsSelector = getServiceOrderSelectedServicesPrices;
    selectedVehicleSelector = selectServiceOrderSelectedVehicle;
    specialRequestsSelector = selectServiceOrderSpecialRequests;
    choosenAlternativeOwner = selectedServiceOrderAlternativeOwner;
    addVehicleDetailsAction = addServiceOrderVehicleDetails;
    closeEditVehicleModalAction = closeServiceOrderEditVehicleModal;
    editVehicleDetailsAction = editServiceOrderVehicleDetails;
    getVehicleByVinAction = getServiceOrderVehicleByVin;
    openEditVehicleModalAction = openServiceOrderEditVehicleModal;
    eitVehicleDataErrorSelector = selectServiceOrderEditVehicleDataError;
    editVehicleModalOpenSelector = selectServiceOrderEditVehicleModalOpen;
    isLoadingVehicleSelector = selectServiceOrderIsLoadingVehicle;
    vehicleNotFoundSelector = selectServiceOrderVehicleNotFound;
    addSpecialRequestAction = addServiceOrderSpecialRequest;
    removeSpecialRequestAction = removeServiceOrderSpecialRequest;
    alternateOwnerSelector = selectServiceOrderAlternativeOwner;
    changeCompletionTypeAction = changeServiceOrderCompletionType;
    setPromiseDateAction = setServiceOrderPromiseDate;
    updateCreatedDateAction = updateServiceOrderCreatedDate;
    estimatedCompletionSelector = selectServiceOrderEstimatedCompletion;
    completionTypeSelector = selectServiceOrderCompletionType;
    promiseDateSelector = selectServiceOrderPromiseDate;
    setAllDealersAction = setAllServiceOrderDealers;
    getAllDealerSelector = getAllServiceOrderDealers;
    setStockNumberForVehicle = setVehicleStockNumber;
    getVehicleId = serviceOrderVehicleId;
  } else {
    clearErrorAction = clearError;
    clearOrderAction = clearNewOrder;
    discardOrderAction = discardOrder;
    saveOrderAction = saveNewOrder;
    dataToSaveSelector = selectDataToSave;
    discardedSelector = selectDiscarded;
    saveErrorSelector = selectSaveError;
    selectWorkOrderSavedSelector = selectWorkOrderSaved;
    isLoadingSelector = selectIsLoading;
    selectedCategoriesSelector = selectSelectedCategories;
    setSelectedVendorAction = setSelectedVendor;
    selectedVendorSelector = selectSelectedVendor;
    getServicesByDepartmentAction = getServicesByDepartment;
    addPriceToSelectedPricesAction = addPriceToSelectedPrices;
    removePriceToSelectedPricesAction = removePriceToSelectedPrices;
    alternativeOwnerAction = alternativeOwner;
    setAlternativeOwnerAction = setAlternativeOwner;
    selectIsLoadingServicesSelector = selectIsLoadingServices;
    selectPricesGroupedSelector = selectPricesGrouped;
    selectedDepartmentSelector = selectSelectedDepartment;
    selectedPricesSelector = selectSelectedPrices;
    selectedPricesWithDetailsSelector = selectSelectedPricesWithDetails;
    selectedVehicleSelector = selectSelectedVehicle;
    specialRequestsSelector = selectSpecialRequests;
    choosenAlternativeOwner = selectedAlternativeOwner;
    addVehicleDetailsAction = addVehicleDetails;
    closeEditVehicleModalAction = closeEditVehicleModal;
    editVehicleDetailsAction = editVehicleDetails;
    getVehicleByVinAction = getVehicleByVin;
    openEditVehicleModalAction = openEditVehicleModal;
    eitVehicleDataErrorSelector = selectEditVehicleDataError;
    editVehicleModalOpenSelector = selectEditVehicleModalOpen;
    isLoadingVehicleSelector = selectIsLoadingVehicle;
    vehicleNotFoundSelector = selectVehicleNotFound;
    addSpecialRequestAction = addSpecialRequest;
    removeSpecialRequestAction = removeSpecialRequest;
    alternateOwnerSelector = selectAlternativeOwner;
    changeCompletionTypeAction = changeCompletionType;
    setPromiseDateAction = setPromiseDate;
    updateCreatedDateAction = updateCreatedDate;
    estimatedCompletionSelector = selectEstimatedCompletion;
    completionTypeSelector = selectCompletionType;
    promiseDateSelector = selectPromiseDate;
    setAllDealersAction = setAllDealers;
    getAllDealerSelector = getAllDealers;
    setStockNumberForVehicle = setStockNumber;
    getVehicleId = vehicleId;
  }
  return {
    clearErrorAction,
    clearOrderAction,
    discardOrderAction,
    saveOrderAction,
    dataToSaveSelector,
    discardedSelector,
    saveErrorSelector,
    selectWorkOrderSavedSelector,
    isLoadingSelector,
    selectedCategoriesSelector,
    setSelectedVendorAction,
    selectedVendorSelector,
    getServicesByDepartmentAction,
    addPriceToSelectedPricesAction,
    removePriceToSelectedPricesAction,
    alternativeOwnerAction,
    setAlternativeOwnerAction,
    selectIsLoadingServicesSelector,
    selectPricesGroupedSelector,
    selectedDepartmentSelector,
    selectedPricesSelector,
    selectedPricesWithDetailsSelector,
    selectedVehicleSelector,
    specialRequestsSelector,
    choosenAlternativeOwner,
    addVehicleDetailsAction,
    closeEditVehicleModalAction,
    editVehicleDetailsAction,
    getVehicleByVinAction,
    openEditVehicleModalAction,
    eitVehicleDataErrorSelector,
    editVehicleModalOpenSelector,
    isLoadingVehicleSelector,
    vehicleNotFoundSelector,
    addSpecialRequestAction,
    removeSpecialRequestAction,
    alternateOwnerSelector,
    changeCompletionTypeAction,
    setPromiseDateAction,
    updateCreatedDateAction,
    estimatedCompletionSelector,
    completionTypeSelector,
    promiseDateSelector,
    setAllDealersAction,
    getAllDealerSelector,
    setStockNumberForVehicle,
    getVehicleId,
  };
};
